import PermissionModuleTable                from "./PermissionModuleTable";

import { BackOfficeContext }                from "../../contexts/BackOfficeContext";
import { usePushNotifications  }            from "../../contexts/PushNotificationsContext";
import { useContext, useEffect, useState }  from "react";
import api                                  from '../../services/api.js'

function PermissionModuleTableContainer () {

    const { selectedGroup }                      = useContext(BackOfficeContext)
    const { setContentPushNotification }         = usePushNotifications()

    const [ permissionsData, setPermissionsData] = useState([])
    const [ loading, isLoading ]                 = useState(true)

    const fetchPermissionsData =  async () => {
        isLoading(true)
        try{
            const response = await api.get(`getPermissionsByUserGroupId/${selectedGroup.value}`)
            setPermissionsData(response.data)
        }catch(error){
            setContentPushNotification({title: "Erro", message: "erro ao acessar permissões."})
        } finally {
            isLoading(false)
        }
    }

    const handlerSubmit = async (updatedPermissionData) => {

        const cleanUpdatedData = updatedPermissionData.map(({ ownerPermissionModule, ...rest }) => rest);
        try{

            const response = await api.put(`updatePermissionsByUserGroupId/${selectedGroup.value}`, { permissionsData: cleanUpdatedData})

            setContentPushNotification({title: "Sucesso",   message: "Permissões atualizadas."})
        }catch(error){
            setContentPushNotification({title: "Erro",      message: "erro ao atualizar permissões."})
        }
    }

    useEffect(() => {
        
        if (selectedGroup){
            fetchPermissionsData()
        }

    }, [selectedGroup?.value])

   

    return (
        <> { loading ? (

            <table className="table-pattern-sistem w-[50%] borda-cinza mt-4">

                <thead className="bg-neutro">
                    <tr>
                        <th><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></th>
                        <th><div className='one h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></th>
                        <th><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></th>
                        <th><div className='one h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></th>

                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[110px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[110px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[50px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='one h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>
                    <tr>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[90px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[70px] bg-neutro rounded-[12px]'> </div></td>
                        <td><div className='two h-[20px] w-[110px] bg-neutro rounded-[12px]'> </div></td>

                    </tr>

                </tbody>
            </table>
        
        ) : (

            <PermissionModuleTable tableData={permissionsData} onSubmit={handlerSubmit}/>

        )}
        </>
    )

}

export default PermissionModuleTableContainer;